import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20soft%20gradients%20of%20warm%20orange%20and%20cream%20tones%2C%20subtle%20comic%20panel%20grid%20pattern%20in%20background%2C%20minimalist%20and%20clean%2C%20modern%20design%20aesthetic%2C%20warm%20atmospheric%20lighting%2C%20suitable%20for%20a%20reading%20platform%20hero&width=1800&height=900&seq=hero-bg-hanman&orientation=landscape"
        alt="韩漫之家"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
          韩漫下载安装
          <br />
          <span className="text-accent-400">随时随地离线看韩漫全集</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          韩漫之家提供海量韩漫资源，支持韩漫离线免费下载到手机。
          韩漫APK轻松获取，无需网络也能畅享韩漫世界。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/article/5"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-base font-medium rounded-full hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/25 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
            下载韩漫APK
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-white text-base font-medium rounded-full border border-white/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-lg w-5 h-5 flex items-center justify-center"></i>
            浏览韩漫分类
          </Link>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { value: '10,000+', label: '韩漫资源' },
            { value: '500,000+', label: '活跃用户' },
            { value: '4.8', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-sm text-white/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}